<template>
  <el-form :model="rechargeForm" label-width="80px" :loading="loading">
    <el-form-item label="充值数量" required>
      <el-input placeholder="比如充值金额或者是课时数量" v-model="rechargeForm.value"/>
    </el-form-item>
    <el-form-item label="支付信息">
      <el-input placeholder="比如用户用支付宝或者微信付款的订单号" v-model="rechargeForm.payInfo"/>
    </el-form-item>
    <el-form-item label="有效期">
      <el-col :span="5">
        <el-form-item>
          <el-date-picker value-format="yyyy-MM-dd" placeholder="开始日期" v-model="rechargeForm.startDate"/>
        </el-form-item>
      </el-col>
      <el-col :span="5" style="margin-left:6rem">
        <el-form-item>
          <el-date-picker value-format="yyyy-MM-dd" placeholder="结束日期" v-model="rechargeForm.endDate"/>
        </el-form-item>
      </el-col>
      <el-col :span="5" style="margin-left:6rem">
        <el-form-item><div>为空则不限期</div></el-form-item>
      </el-col>
    </el-form-item>
    <el-form-item label="备注">
      <el-input type="textarea" placeholder="比如承诺给客户赠送的物品或者优惠信息" v-model="rechargeForm.remark" multiline/>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="save">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import {recharge} from './skuApi'

export default {
  name: 'skuRecharge',
  data () {
    return {
      loading: false,
      rechargeForm: {
        value: '',
        payInfo: '',
        remark: '',
        startDate: null,
        endDate: null
      }
    }
  },
  props: {
    customer () {
      return null
    },
    sku () {
      return null
    }
  },
  watch: {
    customer (v) {
      this.rechargeForm = {
        value: '',
        payInfo: '',
        remark: '',
        startDate: null,
        endDate: null
      }
    },
    sku (v) {
      this.rechargeForm = {
        value: '',
        payInfo: '',
        remark: '',
        startDate: null,
        endDate: null
      }
    }
  },
  methods: {
    save () {
      this.loading = true
      const endLoading = () => {
        this.loading = false
      }
      this.rechargeForm.customerId = this.customer.customerId
      this.rechargeForm.skuId = this.sku.skuId
      recharge(this.rechargeForm).catch(endLoading).then(rsp => {
        const { code } = rsp
        endLoading()
        if (code === 0) {
          this.$message.success('充值成功')
          this.$emit('close')
          this.$emit('success')
        } else {
          const { message } = rsp
          this.$message.error(message)
        }
      })
    },
    cancel () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sku/skuRecharge.vue